import { useQueryClient } from '@tanstack/react-query'
import { AccessLevelSetting as Input, toast } from 'ui-components'
import { useAuth } from 'user-auth'
import { updateMapAccess } from '~map-preview/api/updateMapAccess'
import { useRefetchMap } from '~map-preview/hooks/useRefetchMap'
import { useMap } from '~map-preview/states/map'

function PublicShare() {
  const { user } = useAuth()
  const map = useMap()
  const query = useQueryClient()
  const { refetch } = useRefetchMap()

  const handleChange = async (_, value) => {
    if (value !== map.isPublic) {
      // Optimistically update the UI
      const previousMap = query.getQueryData(['getMapById', map.id])

      query.setQueryData(['getMapById', map.id], (oldData) => {
        if (!oldData) return oldData
        return { ...oldData, isPublic: value } // Immutable update
      })

      try {
        await updateMapAccess({ id: map.id, isPublic: value })
        refetch()
      } catch (error) {
        // Rollback on failure
        query.setQueryData(['getMapById', map.id], previousMap)
        toast('Access level update failed')
      }
    }
  }

  return (
    <Input
      value={map.isPublic}
      onChange={handleChange}
    />
  )
}

export { PublicShare }
